<template>
	<div class="telephone-ui">
		<div class="telephone-box" @click="makePhoneCall(item)" v-for="(item,i) in datas.items" :key="i" v-if="datas.items">
			<div class="phoneNumber" >
				<div :style="{'color':datas.textColor}">{{item.name}}:{{item.phoneNumber}}</div>
				</div>
			<img class="img" :src="item.backgroundImg" mode="widthFix">
		</div>
		<div class="telephone-box" @click="makePhoneCall(datas)" v-else>
		
			<img class="img" :src="datas.backgroundImg" mode="widthFix">
		</div>
	</div>
	
</template>

<script>
	// 标题

	export default {
		name: "telephone",
		props: {
			datas: Object
		},
		methods: {
			makePhoneCall(item) {
				window.location.href = `tel://${item.phoneNumber}`
			}
		},
		computed: {
			
			
		},
		mounted(){
			
		}
	};
</script>

<style lang="less">
	.telephone-ui{
		padding: 0 0.4rem;
		.telephone-box{
			margin-top: 10px;
			position: relative;
			border-radius: 6px;
			&:first-child{
				margin-top: 0;
			}
			.phoneNumber{
				display: flex;
				align-items: center;
				position: absolute;	
				left: 0;
				right: 0;
				top: 50%;
				transform: translateY(-50%);
				padding: 0 10px 0 28px;
				font-size:15px;
				color: #333;
				
			}
			.img{
				display: block;

				width: 100%;
			}
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/components/polymerization/telephone.vue